/**
 * Messages d'erreur Stripe en français.
 * Extraits et nettoyés depuis les composants legacy Symfony.
 */

const SEPA_ERROR_MESSAGES: Record<string, string> = {
  invalid_account_number: "L'IBAN saisi est invalide. Veuillez vérifier et ressaisir votre IBAN.",
  account_number_invalid: "L'IBAN saisi est invalide. Veuillez vérifier et ressaisir votre IBAN.",
  routing_number_invalid: 'Le code banque de votre IBAN est invalide.',
  bank_account_declined: "Votre banque a refusé l'autorisation de prélèvement.",
  debit_not_authorized: "Le prélèvement SEPA n'est pas autorisé sur ce compte.",
  insufficient_funds: 'Fonds insuffisants sur votre compte.',
  processing_error: 'Une erreur technique est survenue. Veuillez réessayer.',
  rate_limit: 'Trop de tentatives. Veuillez patienter quelques minutes.',
  api_connection_error: 'Problème de connexion. Vérifiez votre connexion internet.',
  api_error: 'Erreur du service de paiement. Veuillez réessayer plus tard.',
  authentication_required: 'Une authentification supplémentaire est requise.',
  setup_intent_authentication_failure: "L'authentification a échoué. Veuillez réessayer.",
  setup_intent_unexpected_state: 'Le processus de paiement est dans un état inattendu.',
};

const CARD_ERROR_MESSAGES: Record<string, string> = {
  card_declined: 'Votre carte a été refusée. Veuillez essayer une autre carte.',
  insufficient_funds: 'Fonds insuffisants. Veuillez utiliser une autre carte.',
  expired_card: 'Votre carte a expiré. Veuillez utiliser une autre carte.',
  incorrect_cvc: 'Le code CVC est incorrect. Veuillez vérifier.',
  incorrect_number: 'Le numéro de carte est incorrect.',
  invalid_expiry_month: "Le mois d'expiration est invalide.",
  invalid_expiry_year: "L'année d'expiration est invalide.",
  processing_error: 'Une erreur technique est survenue. Veuillez réessayer.',
  rate_limit: 'Trop de tentatives. Veuillez patienter quelques minutes.',
  api_connection_error: 'Problème de connexion. Vérifiez votre connexion internet.',
  api_error: 'Erreur du service de paiement. Veuillez réessayer plus tard.',
  authentication_required: 'Authentification 3D Secure requise.',
  payment_intent_authentication_failure: "L'authentification 3D Secure a échoué.",
};

function resolveError(error: any, messages: Record<string, string>, defaultMsg: string): string {
  if (error?.code && messages[error.code]) {
    return messages[error.code];
  }

  if (error?.type) {
    switch (error.type) {
      case 'validation_error':
        return 'Les informations saisies sont incorrectes. Veuillez vérifier.';
      case 'api_connection_error':
        return 'Problème de connexion. Vérifiez votre connexion internet.';
      case 'api_error':
        return 'Erreur du service de paiement. Veuillez réessayer plus tard.';
      case 'rate_limit_error':
        return 'Trop de tentatives. Veuillez patienter quelques minutes.';
    }
  }

  return error?.message || defaultMsg;
}

export function getSepaErrorMessage(error: any): string {
  return resolveError(
    error,
    SEPA_ERROR_MESSAGES,
    'Une erreur est survenue lors du prélèvement SEPA. Veuillez réessayer.',
  );
}

export function getCardErrorMessage(error: any): string {
  return resolveError(
    error,
    CARD_ERROR_MESSAGES,
    'Une erreur est survenue lors du paiement par carte. Veuillez réessayer.',
  );
}
